import { render, staticRenderFns } from "./roleMenu.vue?vue&type=template&id=3a1ddfc0&scoped=true&"
import script from "./roleMenu.vue?vue&type=script&lang=js&"
export * from "./roleMenu.vue?vue&type=script&lang=js&"
import style0 from "./roleMenu.vue?vue&type=style&index=0&id=3a1ddfc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ddfc0",
  null
  
)

export default component.exports